import { render, staticRenderFns } from "./Loader.vue?vue&type=template&id=250f89bc&scoped=true&"
import script from "./Loader.vue?vue&type=script&setup=true&lang=ts&"
export * from "./Loader.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./Loader.vue?vue&type=style&index=0&id=250f89bc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "250f89bc",
  null
  
)

export default component.exports